import {
  masmovilCard,
  llamayaCard,
  llamayaLink,
  masmovilLink,
  CustomTheme,
} from '@masfront/common-b2c'

import { makeStyles } from '@material-ui/core/styles'

const useTariffCardStyles = makeStyles<
  CustomTheme,
  { maxNumberOfPrices: number; numberOfPrices: number }
>(({ palette, spacing, name }: CustomTheme) => ({
  root: {
    paddingTop: '37px',
  },
  cardContainer: {
    cursor: 'pointer',
    overflow: 'visible',
    position: 'relative',
    transition: 'all 0.45s ease-out',
    width: '192px',
    '&:hover': {
      transform: 'scale(1.02,1.02)',
      transition: 'all 0.25s ease-out',
    },
  },
  selected: {
    backgroundColor:
      name === 'masmovil' ? masmovilCard.backgroundColor : llamayaCard.backgroundColor,
  },
  topContainer: {
    alignItems: 'flex-end',
    display: 'flex',
    height: '32px',
    justifyContent: 'flex-end',
    textAlign: 'right',
  },
  top: {
    backgroundColor: name === 'masmovil' ? masmovilLink.light : llamayaLink.light,
    borderRadius: '2px',
    color: '#FFFFFF',
    fontSize: '10px',
    marginRight: spacing(4),
    padding: '2px',
    right: '0',
    textAlign: 'center',
    width: '39px',
  },
  iconContainer: {
    alignItems: 'center',
    backgroundColor: name === 'masmovil' ? masmovilCard.mainColor : llamayaCard.mainColor,
    borderRadius: '64px',
    display: 'flex',
    height: '64px',
    justifyContent: 'center',
    left: '50%',
    position: 'absolute',
    top: '-32px',
    transform: 'translate(-50%,0)',
    width: '64px',
  },
  icon: {
    color: '#333333',
    fontSize: 25,
  },
  title: {
    color: palette.grey[900],
    marginBottom: spacing(2),
    minHeight: '40px',
    textTransform: 'uppercase',
  },
  content: {
    padding: `${spacing(4)}px ${spacing(2)}px 0px`,
    textAlign: 'center',
  },
  info: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    '& p:first-child': {
      marginRight: spacing(1),
      textTransform: 'capitalize',
    },
    '& p:last-child': {
      color: '#4c4c4c',
    },
  },
  mainPrice: {
    alignItems: 'center',
    backgroundColor: name === 'masmovil' ? masmovilCard.mainColor : llamayaCard.mainColor,
    borderRadius: ({ maxNumberOfPrices, numberOfPrices }) =>
      maxNumberOfPrices > 1 && numberOfPrices > 1 ? '8px 8px 0 0' : '8px',
    display: 'flex',
    height: ({ maxNumberOfPrices, numberOfPrices }) => {
      if (maxNumberOfPrices === 1 && numberOfPrices === 1) return '48px'
      if (maxNumberOfPrices > 1 && numberOfPrices > 1) return '48px'
      return maxNumberOfPrices === 2 && numberOfPrices === 1 ? '80px' : '103px'
    },
    justifyContent: 'center',
  },
  otherPriceContainer: {
    backgroundColor: name === 'masmovil' ? masmovilCard.mainColor : llamayaCard.mainColor,
    borderRadius: '0 0 8px 8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: '2px',
    minHeight: ({ maxNumberOfPrices, numberOfPrices }) => {
      if (maxNumberOfPrices > 2 && numberOfPrices === 1) return '0'
      return maxNumberOfPrices > 2 && numberOfPrices <= 2 ? '52px' : 'auto'
    },
    width: '100%',
  },
  secondPrice: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: spacing(2),
    '&:last-child': {
      marginBottom: spacing(2),
    },
    '& span:last-child': {
      marginLeft: spacing(2),
    },
  },
  buttonContainer: {
    justifyContent: 'center',
    paddingBottom: spacing(4),
  },
}))

export default useTariffCardStyles
